import { MouseEvent, ReactNode } from 'react';

import { IconButton } from '@mui/material';
import { IconButtonProps } from '@mui/material/IconButton';

export const ActionIconButton = ({
  children,
  sx,
  ...rest
}: {
  children?: ReactNode;
  sx?: IconButtonProps['sx'];
  onClick?: (event: MouseEvent<HTMLElement>) => void;
}) => {
  return (
    <IconButton
      sx={(theme) => ({
        border: '1px solid',
        borderColor: theme.palette.divider,
        width: '32px',
        height: '32px',
        ...(sx as any),
      })}
      {...rest}
    >
      {children}
    </IconButton>
  );
};
